module.exports = __webpack_public_path__ + "static/media/diners.cca4a6ab.svg";